"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPartnerProgramEligibleSelector = void 0;

var _Scopes = require("pricing-pages-unified-ui/constants/Scopes");

var isPartnerProgramEligibleSelector = function isPartnerProgramEligibleSelector(_ref) {
  var auth = _ref.auth;
  var user = auth.user;
  if (!user) return false;
  var scopes = user.scopes;
  if (!scopes) return false;
  var isDirectoryUser = scopes.some(function (scope) {
    return scope === _Scopes.DIRECTORY_USER;
  });
  var isPartner = scopes.some(function (scope) {
    return scope === _Scopes.PARTNER_LEAD_REGISTRATION;
  });
  return isDirectoryUser && !isPartner;
};

exports.isPartnerProgramEligibleSelector = isPartnerProgramEligibleSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/PartnerProgramSelectors.js
// module id = 479
// module chunks = 5 6 7